import { createSelector } from '@ngrx/store';

import { ISpatialDrawingState } from '@live/reducers/live-spatial.reducer';

import { selectLiveEdgeState } from './live-edge-base.selectors';
import { IState } from '../reducers';

// Feature selector
// Spatial state selector
export const selectSpatialState = createSelector(selectLiveEdgeState, (state: IState) => state.spatial);

export const selectAllEntities = createSelector(selectSpatialState, (spatial: ISpatialDrawingState) => spatial.entities);
export const selectIsLoaded = createSelector(selectSpatialState, (spatial: ISpatialDrawingState) => spatial.isLoaded);
export const selectIsError = createSelector(selectSpatialState, (spatial: ISpatialDrawingState) => spatial.isError);

// Tool selection selectors
export const selectCurrentDrawingTool = createSelector(selectSpatialState, (spatial: ISpatialDrawingState) => spatial.selectedTool);

export const selectHasSelectedTool = createSelector(selectCurrentDrawingTool, tool => tool != null);

// Edit mode selectors
export const selectIsEditMode = createSelector(selectSpatialState, (spatial: ISpatialDrawingState) => spatial.isEditMode);
export const selectCurrentEditableRuleId = createSelector(selectSpatialState, (spatial: ISpatialDrawingState) => spatial.currentEditableRuleId);

// Drawing state selectors
export const selectIsDrawing = createSelector(selectSpatialState, (spatial: ISpatialDrawingState) => spatial.isDrawing);

// Combined selectors
export const selectCanDrawingStart = createSelector(
  selectIsEditMode,
  selectIsDrawing,
  selectHasSelectedTool,
  (isEditMode, isDrawing, hasSelectedTool) => isEditMode && !isDrawing && hasSelectedTool
);

export const selectSpatialControlsState = createSelector(selectCurrentDrawingTool, selectIsEditMode, (selectedTool, isEditMode) => ({
  selectedTool,
  isEditMode
}));

export const selectCounterFilters = createSelector(selectSpatialState, (spatial: ISpatialDrawingState) => spatial.counterFilters);
export const selectBoxFilters = createSelector(selectSpatialState, (spatial: ISpatialDrawingState) => spatial.boxFilters);

// In-progress shape selector
export const selectInProgressShape = createSelector(selectSpatialState, (spatial: ISpatialDrawingState) => spatial.inProgressShape);

// Completed shapes count selector
export const selectCompletedShapesCount = createSelector(selectAllEntities, entities => Object.keys(entities).length);

// Tools availability selector
export const selectAreToolsAvailable = createSelector(selectCompletedShapesCount, count => count < 10);

// Monitored zones selector
export const selectMonitoredZones = createSelector(selectSpatialState, (spatial: ISpatialDrawingState) => spatial.monitoredZones);
